import { createElementBlock as o, openBlock as r, createElementVNode as n } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return r(), o("svg", t, e[0] || (e[0] = [
    n("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.263 5.71v.181c0 .558-.222 1.094-.617 1.489l-3.157 3.158a2.105 2.105 0 0 1-2.978 0L7.353 7.38a2.1 2.1 0 0 1-.616-1.489v-.18m10.526 0V3.605A2.105 2.105 0 0 0 15.158 1.5H8.842a2.105 2.105 0 0 0-2.105 2.105v2.106m10.526 0H6.737m0 15.789h10.526m-10.526 0 3.948-3.158a2.105 2.105 0 0 1 2.63 0l3.948 3.158m-10.526 0v-4.391c0-.559.222-1.094.616-1.489l3.158-3.158a2.105 2.105 0 0 1 2.978 0l3.157 3.158c.395.395.617.93.617 1.489V21.5"
    }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
